@if (!config.hide) {
  <div [ngClass]="config.class">
    <mat-label class="select-label content-label" >{{config.label}}</mat-label>
    <span class="content-value">{{config.value ? config.value : '-'}}</span>
  </div>
}